// src/firebase/auth/signup.js
import firebase_app from "../config";
import { createUserWithEmailAndPassword, getAuth, updateProfile, sendEmailVerification } from "firebase/auth";
import { getFirestore, setDoc, doc } from "firebase/firestore";

const auth = getAuth(firebase_app);
const db = getFirestore(firebase_app);

export default async function signUp(email, password, fullName, phoneNumber, selectedCourse = null) {
  let result = null;
  let error = null;
  
  console.log("🚀 Starting signUp process for:", email);
  
  try {
    if (!email || !password || !fullName) {
      throw new Error("Missing required fields");
    }
    
    if (password.length < 6) {
      throw new Error("Password must be at least 6 characters");
    }
    
    result = await createUserWithEmailAndPassword(auth, email, password);
    console.log("✅ User created successfully:", result.user.uid);
    
    await updateProfile(result.user, {
      displayName: fullName
    });
    console.log("✅ Profile updated");
    
    // Отправляем письмо без кастомной обработки (используем стандартный шаблон Firebase)
    await sendEmailVerification(result.user);
    console.log("✅ Verification email sent to:", email);
    
    const userData = {
      email: result.user.email,
      userId: result.user.uid,
      fullName: fullName,
      phoneNumber: phoneNumber || '',
      selectedCourse: selectedCourse || null,
      balance: 0,
      favorites: [],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      role: 'user',
      emailVerified: false,
      userType: 'web'
    };
    
    await setDoc(doc(db, "webUsers", result.user.uid), userData);
    console.log("✅ User data saved to Firestore");
    
    if (selectedCourse) {
      const academyData = {
        email: result.user.email,
        user_id: result.user.uid,
        full_name: fullName,
        phone_number: phoneNumber,
        selected_course: selectedCourse,
        emailVerified: false,
        createdAt: new Date().toISOString()
      };
      
      await setDoc(doc(db, "Academy Users", result.user.uid), academyData);
      console.log("✅ User data saved to Academy Users");
    }
    
  } catch (e) {
    console.error("❌ SignUp error:", e);
    
    if (e.code === 'auth/email-already-in-use') {
      error = new Error("Пользователь с таким email уже существует");
    } else if (e.code === 'auth/invalid-email') {
      error = new Error("Неверный формат email");
    } else if (e.code === 'auth/weak-password') {
      error = new Error("Пароль слишком слабый (минимум 6 символов)");
    } else if (e.code === 'auth/unauthorized-continue-uri') {
      error = new Error("Домен не разрешен. Добавьте inner-art.net в Authorized domains в Firebase Console");
    } else {
      error = e;
    }
  }
  
  return { result, error };
}